import React from "react";
import { Box, Divider } from "@mui/material";
import ListComponentNav from "../ListComponentNav";

const Sidebar: React.FC = () => {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          py: 2,
          px: 1,
          backgroundColor: '#1c2e4a',
        }}
      >
        <img
          src="/img/logo_white.png"
          alt="Logo TribuNex - Sistema de gestão tributária"
          aria-label="Logo do sistema TribuNex"
          style={{
            width: 180,
            maxWidth: '90%',
            height: 'auto',
            display: 'block',
          }}
        />
      </Box>

      <Divider sx={{ borderColor: '#ffffff22', mb: 1 }} />

      <ListComponentNav />
    </>
  );
};

export default Sidebar;
